import React, { useState } from 'react';

import { type EmailMessagesFilterInput } from '@dashboard/generated/wp/platform';
import { ArrowCircleRight, SearchOutlined } from '@mui/icons-material';
import { Box, IconButton, TextField } from '@mui/material';

type Props = {
  filter: EmailMessagesFilterInput;
  setFilter: (value: EmailMessagesFilterInput) => void;
  setAnchorEl: (v: null) => void;
};
export default function SearchForm({ filter, setFilter, setAnchorEl }: Props) {
  const [queryValue, setQueryValue] = useState(filter.query ?? '');

  const onSubmit = (ev: React.FormEvent<HTMLFormElement>) => {
    ev.preventDefault();
    setFilter({ ...filter, query: queryValue });
    setAnchorEl(null);
  };

  return (
    <form onSubmit={onSubmit}>
      <TextField
        variant="outlined"
        size="small"
        autoFocus
        sx={{ minWidth: { sm: 480 } }}
        placeholder="Find in activity"
        value={queryValue}
        onChange={(e) => setQueryValue(e.target.value)}
        InputProps={{
          sx: { pr: 1 },
          startAdornment: (
            <Box display="inline-flex" pr={1}>
              <SearchOutlined fontSize="small" sx={{ color: 'text.secondary' }} />
            </Box>
          ),
          endAdornment: (
            <IconButton type="submit" size="small" edge="end">
              <ArrowCircleRight color="primary" fontSize="small" />
            </IconButton>
          ),
        }}
      />
    </form>
  );
}
